import { RouteRecordName } from 'vue-router';
import router from '../router';
import { DASHBOARD_ROUTE } from './routes'

export const redirectOn404 = (to: any, from: { name: RouteRecordName | null; }) => {
    if (from.name != null) {
        const route = router.resolve({ name: from.name })

        // if previous router is a route that exists, then redirect back to that route
        if (route && route.href !== '/') {
            router.push({ name: from.name })
            return
        }
    }

    // else go to home route
    router.push({ name: DASHBOARD_ROUTE })
}
